

































import { defineComponent, PropType } from '@vue/composition-api';
import type { ReportRouteSlim, RoutePosition, ContextMenuMode } from '@/models/runCourse';
import { dtFormat } from '@/lib/dateHelper';

export default defineComponent({
  props: {
    route: {
      type: Object as PropType<ReportRouteSlim>,
      required: true,
    },
    isLastRoute: {
      type: Boolean,
      required: true,
    },
    sheetIdx: {
      type: Number,
      required: true,
    },
    rowIdx: {
      type: Number,
      required: true,
    },
    routeIdx: {
      type: Number,
      required: true,
    },
  },
  emits: ['edit', 'show-contextmenu', 'create', 'blur'],
  setup(props, { emit }) {
    const position = (): RoutePosition => ({
      sheetIdx: props.sheetIdx,
      rowIdx: props.rowIdx,
      routeIdx: props.routeIdx,
    });

    const onEditClick = () => {
      emit('edit', props.route, position());
    };

    const onArrowClick = (event: MouseEvent) => {
      const mode: ContextMenuMode = 'separate';
      emit('show-contextmenu', event, position(), mode);
    };

    const onPlusClick = () => {
      emit('create', position());
    };

    const onEllipsisClick = (event: MouseEvent) => {
      const mode: ContextMenuMode = 'combine';
      emit('show-contextmenu', event, position(), mode);
    };

    return {
      onEditClick,
      onArrowClick,
      onPlusClick,
      onEllipsisClick,
      dtFormat,
    };
  },
});
